import { BaseModel, type RelationConfig } from './base';

import { Employee } from './employee';

// Enums

export enum StockTakeStatus {
  open = 0,
  applied = 1,
}

export const StockTakeStatusLabels: Record<StockTakeStatus, string> = {
  [StockTakeStatus.open]: 'general.open',
  [StockTakeStatus.applied]: 'stockTake.applied',
};

// Main Model

export class StockTake extends BaseModel {
  idStockTake!: number;
  status!: StockTakeStatus;
  employee!: Employee | null;

  static override relations(): RelationConfig {
    return {
      employee: { type: Employee },
    };
  }

  override objectID(): string | null {
    return this.idStockTake?.toString() ?? null;
  }

  get isStatusOpen(): boolean {
    return this.status === StockTakeStatus.open;
  }

  get isStatusApplied(): boolean {
    return this.status === StockTakeStatus.applied;
  }
}
